import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { SerasaPersonRow } from 'src/modules/motor-credito/serasa/serasa.pf.types'

export type IdentificacaoProps = {
    person: SerasaPersonRow
}

export default function Identificacao({ person }: IdentificacaoProps) {
    return (
        <>
            <Divider textAlign="center">Identificação</Divider>

            <Grid
                container
                spacing={1}
                sx={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5
                }}
            >
                <GridItem label="Titular" value={person.identificacao.titular} xs={8} />
                <GridItem label="CPF" value={person.identificacao.cpf} xs={4} />

                <GridItem label="Nome da Mãe" value={person.identificacao.nome_mae} xs={4} />
                <GridItem label="Nacionalidade" value={person.identificacao.nacionalidade} xs={4} />
                <GridItem label="Sexo" value={person.identificacao.sexo} xs={4} />

                <GridItem label="Estado Civil" value={person.identificacao.estado_civil} xs={8} />
                <GridItem
                    label="Ultima Alt. Cadastral"
                    value={formatDate(person.identificacao.ult_alt_cadastral, 'dd/MM/yyyy HH:mm')}
                    xs={4}
                />

                <GridItem label="Situação Data" value={formatDate(person.situacao.data, 'dd/MM/yyyy HH:mm')} xs={4} />
                <GridItem label="Situação Status" value={person.situacao.status} xs={8} />
            </Grid>

            {person.nascimento && (
                <>
                    <Divider textAlign="center">Nascimento</Divider>

                    <Grid
                        container
                        spacing={1}
                        sx={{
                            paddingTop: 2,
                            paddingBottom: 2,
                            paddingLeft: 5,
                            paddingRight: 5
                        }}
                    >
                        <GridItem label="Data" value={formatDate(person.nascimento.data, 'dd/MM/yyyy')} xs={4} />
                        <GridItem label="Cidade" value={person.nascimento.cidade} xs={4} />
                        <GridItem label="UF" value={person.nascimento.uf} xs={4} />
                    </Grid>
                </>
            )}
            {person.identificacao.rg && (
                <>
                    <Divider textAlign="center">RG</Divider>

                    <Grid
                        container
                        spacing={1}
                        sx={{
                            paddingTop: 2,
                            paddingBottom: 2,
                            paddingLeft: 5,
                            paddingRight: 5
                        }}
                    >
                        <GridItem label="Número" value={person.identificacao.rg.numero} xs={3} />
                        <GridItem label="Órgão" value={person.identificacao.rg.orgao} xs={3} />
                        <GridItem
                            label="Emissão"
                            value={formatDate(person.identificacao.rg.emissao, 'dd/MM/yyyy')}
                            xs={3}
                        />
                        <GridItem label="UF" value={person.identificacao.rg.uf} xs={3} />
                    </Grid>
                </>
            )}
        </>
    )
}
